import { CopyAIcon } from '@prophecy/icons';
import { CUSTOM_STROKE_ICON_CLASS, ICON_CLASS } from '@prophecy/icons/tokens';
import { getInterFontWeightCSS, theme } from '@prophecy/theme';
import { Arrow, Content } from '@radix-ui/react-tooltip';
import styled, { css, keyframes } from 'styled-components';
import { Markdown } from '../Markdown';
import { ENTITY_BADGE_EXTERNAL_LINK_CLASS, ENTITY_BADGE_LEADING_ICON_CLASS, TOOLTIP_INVERTED_ENTITY_BADGE_CLASS } from './constants';
export const tokens = {
    TooltipContent: {
        borderRadius: theme.radius.x8,
        fontSize: theme.text.xs.fontSize,
        fontWeight: theme.fontWeight.semiBold,
        padding: `${theme.spaces.x8} ${theme.spaces.x12}`,
        zIndex: theme.zLayer.xxxl,
        transition: theme.transition.m,
        backgroundColor: theme.colors.gray950,
        color: theme.colors.white
    },
    TooltipDetails: {
        color: theme.colors.gray300,
        paddingTop: theme.spaces.x4,
        paddingRight: theme.spaces.x4
    },
    Arrow: {
        offset: theme.spaces.x12
    }
};
const appear = keyframes `
  0% { 
    opacity: 0;
  }
  100% {
    opacity: 1;
  };
`;
export const tooltipAnimation = css `
  animation: ${appear} ${tokens.TooltipContent.transition} forwards;
`;
export const StyledDetail = styled.span `
  color: ${tokens.TooltipDetails.color};
  padding-top: ${(props) => (props.title ? tokens.TooltipDetails.paddingTop : '0')};
  padding-right: ${(props) => (!props.title ? tokens.TooltipDetails.paddingRight : '0')};
`;
export const StyledMarkDown = styled(Markdown) `
  color: ${tokens.TooltipContent.color};
`;
export const StyledContent = styled(Content) `
  font-family: ${theme.fontFamily.text};
  font-size: ${tokens.TooltipContent.fontSize};
  ${getInterFontWeightCSS(tokens.TooltipContent.fontWeight)};
  padding: ${tokens.TooltipContent.padding};
  background: ${tokens.TooltipContent.backgroundColor};
  border-radius: ${tokens.TooltipContent.borderRadius};
  color: ${tokens.TooltipContent.color};
  z-index: ${tokens.TooltipContent.zIndex};
  max-width: 80vw;
  gap: ${theme.spaces.x4};
  line-height: ${theme.text.xs.lineHeight};
  ${tooltipAnimation}

  scrollbar-width: thin;
  scrollbar-color: ${theme.colors.gray600} ${theme.colors.gray900};
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: ${theme.colors.gray900};
  }
  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray600};
    border-radius: ${theme.radius.full};
  }
  &::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.gray500};
  }

  ${({ $forceTooltipContentColor }) => $forceTooltipContentColor &&
    css `
      * {
        color: ${tokens.TooltipContent.color} !important;
      }

      .${TOOLTIP_INVERTED_ENTITY_BADGE_CLASS},
      .${TOOLTIP_INVERTED_ENTITY_BADGE_CLASS}:hover,
      .${TOOLTIP_INVERTED_ENTITY_BADGE_CLASS}:focus,
      .${TOOLTIP_INVERTED_ENTITY_BADGE_CLASS}:focus-visible {
        background-color: ${theme.colors.gray800} !important;
        border-color: ${theme.colors.gray700} !important;
        color: ${tokens.TooltipContent.color} !important;
      }

      .${TOOLTIP_INVERTED_ENTITY_BADGE_CLASS} .${ENTITY_BADGE_LEADING_ICON_CLASS} .${ICON_CLASS},
      .${TOOLTIP_INVERTED_ENTITY_BADGE_CLASS}
        .${ENTITY_BADGE_LEADING_ICON_CLASS}
        .${CUSTOM_STROKE_ICON_CLASS} {
        color: revert !important;
      }

      .${TOOLTIP_INVERTED_ENTITY_BADGE_CLASS} .${ENTITY_BADGE_EXTERNAL_LINK_CLASS} .${ICON_CLASS} {
        color: ${theme.colors.gray400} !important;
        opacity: 1;
      }

      code {
        background-color: ${theme.colors.gray800} !important;
      }

      pre {
        background: ${theme.colors.gray800} !important;
        border-color: ${theme.colors.gray700} !important;
      }

      pre code {
        background-color: transparent !important;
      }
    `}
`;
export const StyledCopyIcon = styled(CopyAIcon) `
  cursor: pointer;
  z-index: ${theme.zLayer.l};
  background: inherit;
  align-self: center;
`;
export const StyledArrow = styled(Arrow) `
  fill: ${(_props) => tokens.TooltipContent.backgroundColor};
`;
